export default {
  appId: '631b0f9b11a5647356912722',
  analyticsId: 'UA-123014598-40',
  apiUrl: 'https://api.bricodes.com',
  storageUrl: 'https://storage.bricodes.com',
  sentryDsn: 'https://ef8a0eaf088f44d1b86bda92dd989f73@sentry.io/1503419',
  languageCode: 'pl',
};
